module.exports = __webpack_public_path__ + "img/l.cb4e71cd.png";